import styled from '@emotion/styled';
import { ChipElementProps } from 'framework/chip/types';

export const ChipElement = styled.button<ChipElementProps>`
  font-family: ${({ theme }) => theme.font.general.font_family};
  font-size: ${({ theme }) => theme.chip.general.font_size};
  color: ${({ theme }) => theme.font.color.normal};
  line-height: ${({ theme }) => theme.chip.general.font_size};
  border-radius: ${({ theme }) => theme.chip.general.border_radius};
  background: ${({ theme }) => theme.chip.background.normal};
  padding: ${({ theme }) => theme.chip.general.padding};
  border: ${({ theme }) => theme.chip.border.normal};
  z-index: 1;

  ${({ clear, theme }) =>
    clear &&
    `
      &:hover {
        background: ${theme.chip.background.hover};
        border: ${theme.chip.border.hover};
      }

      &:focus {
        background: ${theme.chip.background.focus};
        border: ${theme.chip.border.focus};
      }
    `};
`;
